import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 40px;
  padding: 40px 20px;
  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};

  position: relative;
  margin-top: 0px;

  ${media.greaterThan("medium")`
    margin: 0 auto;
    margin-top: 120px;
    padding: 20px 0;

    max-width: 950px;
  `};
`;

export const BannerArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;

  width: 100vw;
  height: 350px;

  color: ${({ theme }) => theme.colors.neutral.white};

  background-color: ${({ theme }) => theme.colors.neutral.cinza900};
  border: ${({ hasBg }) => !hasBg && "1px dashed #5b5b5b"};

  h2 {
    font-size: 40px;
    text-decoration: underline;
  }

  input {
    display: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;

    max-height: 350px;
  }

  cursor: pointer;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 5px;
`;

export const Title = styled.h2`
  font-size: 40px;
  color: ${({ theme }) => theme.colors.primary.orange};
`;

export const Subtitle = styled.h3`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.neutral.white};
`;

export const Kpis = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 20px;
  align-items: center;

  margin-bottom: 40px;

  position: absolute;
  top: -140px;
  width: 1150px;

  ${media.lessThan("medium")`
    grid-template-columns: 1fr 1fr;
    position: relative;
    top: 0px;
    width: 100%;
  `}
`;

export const Main = styled.div`
  width: 100%;

  background-color: ${({ theme }) => theme.colors.neutral.cinza950};

  padding: 20px 40px;

  display: flex;
  flex-direction: column;
  gap: 30px;

  min-height: 500px;

  ${media.lessThan("medium")`
    padding: 20px;
  `}
`;

export const Projects = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 20px;
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: center;
  align-items: center;
  padding: 15px 20px;
  text-align: center;
`;

export const Project = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;

  cursor: pointer;

  padding: 15px 20px;

  border: 1px solid ${({ theme }) => theme.colors.neutral.white};

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }
`;
